import { useEffect, useRef, useState } from "react";

export function useInViewPort<T extends HTMLElement>({
  threshold = 0.1,
  root = null,
  rootMargin = "0px",
  triggerOnce = true,
}: IntersectionObserverInit & { triggerOnce?: boolean } = {}) {
  const observerRef = useRef<T | null>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const node = observerRef.current;
    if (!node) return;


    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (triggerOnce) observer.disconnect();
        } else if (!triggerOnce) {
          setInView(false);
        }
      },
      { threshold, root, rootMargin }
    );

    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [threshold, root, rootMargin, triggerOnce]);

  return { observerRef, inView };
}
